import * as Yup from 'yup'
import {FieldProps} from './Form'

function fillValues(source: Record<string, any>, target: Record<string, any>): Record<string, any> {
  const result: Record<string, any> = {}

  for (const key in target) {
    if (
      typeof target[key] === 'object' &&
      target[key] !== null &&
      !Array.isArray(target[key]) &&
      !(target[key] instanceof Date)
    ) {
      result[key] = fillValues(source[key] || {}, target[key])
    } else {
      result[key] = source[key]
      // result[key] = source[key] !== undefined ? source[key] : target[key]
    }
  }

  return result
}
export const buildValidationSchema = (
  fields: FieldProps[] | ((options: {values: any}) => FieldProps[]),
  currentUser: any,
  data?: any
) => {
  let flds = typeof fields === 'function' ? fields({values: {}}) : [...fields]
  const fieldObj: any = {}
  let initialValues: any = {}
  flds?.forEach((field) => {
    if (data?.id ? field.edit === false : field.create === false) return

    if (field.type === 'multi-input' && Array.isArray(field.fields)) {
      const subFields = field.fields
      initialValues[field.name] = []
      const initialRow: any = {}
      const fieldRow: any = {}

      subFields.forEach((subField) => {
        initialRow[subField.name] = subField.hasOwnProperty('initialValue')
          ? subField.initialValue
          : subField.type === 'date'
          ? new Date().toISOString().substring(0, 10)
          : subField.type === 'switch'
          ? true
          : ''
        fieldRow[subField.name] = subField
      })
      fieldObj[field.name] = [fieldRow]

      // Only assign default row if data is not present
      if (Array.isArray(data?.[field.name])) {
        initialValues[field.name] = data[field.name].map((row: any) => fillValues(row, initialRow))
      } else if (!initialValues[field.name]) {
        initialValues[field.name] = [initialRow] // ensure it's only created once
      }

      // Add at least one initial empty row
      initialValues[field.name].push(initialRow)
      fieldObj[field.name] = [fieldRow]
    } else {
      const keyParts = field.name.split('.').filter(Boolean)
      let curr = initialValues
      let curr1 = fieldObj
      keyParts.forEach((part, idx) => {
        if (idx === keyParts.length - 1) {
          if (
            currentUser?.role_id === 4 &&
            ['class_id', 'section_id', 'student_id'].includes(part)
          ) {
            curr[part] = currentUser?.[part] || ''
            return
          }
          curr[part] = field.hasOwnProperty('initialValue')
            ? field.initialValue
            : field.type === 'date'
            ? new Date()
            : field.type === 'switch'
            ? true
            : ''
          curr1[part] = field
        } else {
          if (!curr[part]) curr[part] = {}
          if (!curr1[part]) curr1[part] = {}
          curr = curr[part]
          curr1 = curr1[part]
        }
      })
    }
  })

  if (data) {
    initialValues = fillValues(data, initialValues)
    if (data.id) initialValues.id = data.id
  }
  const buildYupSchema = (fieldObj: any) => {
    const schema: any = {}
    Object.entries(fieldObj).forEach(([key, value]: [string, any]) => {
      if (key.includes('[0]')) {
        schema[key.replace('[0]', '')] = Yup.array().of(buildYupSchema(value))
        return
      }
      if (Array.isArray(value)) {
        // It's a multi-input (array of fields)
        const rowSchema = buildYupSchema(value[0])
        schema[key] = Yup.array().of(rowSchema)
        return
      }

      if (!value.name) {
        schema[key] = buildYupSchema(value)
        return
      }

      let validator
      switch (value.type) {
        case 'date':
          validator = Yup.date()
          break
        case 'switch':
          validator = Yup.boolean()
          break
        case 'file':
          validator = Yup.mixed()
          break
        case 'image':
          validator = Yup.mixed()
          break
        case 'multi-select':
          validator = Yup.array().of(Yup.mixed())
          break
        case 'number':
          validator = Yup.number()
          if (value.fieldProps?.min !== undefined) validator = validator.min(value.fieldProps.min)
          if (value.fieldProps?.max !== undefined) validator = validator.max(value.fieldProps.max)
          break
        default:
          validator = Yup.string()
          if (value.type === 'email') validator = validator.email()
      }

      if (value.required) validator = validator.required()

      schema[key] = validator.label(value.label || value.placeholder || key)
    })

    return Yup.object().shape(schema)
  }

  return {schema: buildYupSchema(fieldObj), initialValues}
}
